export default Object.freeze({
  CustomerPaysAutomyStripe: 1,
  ResellerPaysAutomy: 2,
  Manual: 3,
});
